export default "__VITE_ASSET__BQFIr_y$__"